/* LIVA · 3 AL, 2 ÖDE client logic. No dependencies.
 * Truth source is Shopify: eligibility counts come from /cart.js, and "uygulandı" is only ever said when
 * cart.total_discount > 0. Nothing here calculates a price. Rules verified in kanit/v3/indirim-dogrulama.json. */
(() => {
  const cfg = window.bvOffer || { on: false, handles: [] };
  const N = cfg.n || 3;
  const fmt = (c) => { const w = Math.floor(c / 100), k = c % 100; return w.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.') + (k ? ',' + String(k).padStart(2, '0') : '') + ' TL'; };
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const store = { get: (k) => { try { return localStorage.getItem(k); } catch (e) { return null; } }, set: (k, v) => { try { localStorage.setItem(k, v); } catch (e) {} } };
  const read = async () => {
    try { const r = await fetch('/cart.js', { headers: { Accept: 'application/json' } }); if (!r.ok) throw 0; return await r.json(); } catch (e) { return null; }
  };
  const stateOf = (cart) => {
    const c = cart.items.filter((i) => cfg.handles.includes(i.handle)).reduce((a, i) => a + i.quantity, 0);
    const r = c % N, applied = c >= N && cart.total_discount > 0;
    return { c, r, applied, filled: c > 0 && r === 0 ? N : r, off: cart.total_discount, more: N - r };
  };

  /* ---------- Cart drawer: the meter is server-rendered; here it only animates the pip that just filled ---------- */
  let prevFilled = null;
  const bump = () => {
    const m = document.querySelector('[data-bv-meter]'); if (!m) return;
    const f = +m.dataset.filled, c = +m.dataset.count;
    if (prevFilled !== null && c > prevFilled && !reduced.matches) { const li = m.querySelectorAll('.bv-meter__pips li')[f - 1]; if (li) li.classList.add('is-bump'); }
    prevFilled = c;
  };

  /* ---------- Doby'nin Notu (product page) ---------- */
  const initNote = (root) => {
    if (!cfg.on) return;
    const tag = root.querySelector('[data-bv-dnote-tag]'), more = root.querySelector('[data-bv-dnote-more]'), msg = root.querySelector('[data-bv-dnote-msg]');
    const pips = [...root.querySelectorAll('.bv-dnote__pips i')], host = root.querySelector('[data-bv-dby="pdp"]'), live = root.querySelector('[data-bv-dby-live]');
    const off = store.get('bv-dnote-off') === '1';
    let last = null, cooling = 0;
    const doby = (name, arg) => { if (off || !host || !window.BvDoby || Date.now() < cooling) return false; cooling = Date.now() + 900; return window.BvDoby.playOn(host, name, arg); };
    const say = (t) => { if (live) { live.textContent = ''; setTimeout(() => { live.textContent = t; }, 50); } };
    const open = (v) => {
      tag.setAttribute('aria-expanded', v ? 'true' : 'false'); root.classList.toggle('is-open', v);
      more.setAttribute('aria-hidden', v ? 'false' : 'true'); if ('inert' in more) more.inert = !v;
    };
    open(false);
    tag.addEventListener('click', () => open(tag.getAttribute('aria-expanded') !== 'true'));
    root.querySelector('[data-bv-dnote-off]').addEventListener('click', () => { store.set('bv-dnote-off', '1'); root.classList.add('is-off'); open(false); });
    const hit = root.querySelector('[data-bv-dnote-hit]');
    if (hit) hit.addEventListener('click', () => open(true));
    document.querySelectorAll('[data-bv-dnote-open]').forEach((a) => a.addEventListener('click', () => {
      open(true); if (!reduced.matches) setTimeout(() => doby('tip'), 450);
    }));
    if (off) root.classList.add('is-off');

    const render = (st, first) => {
      const key = st.c + ':' + st.applied;
      pips.forEach((p, i) => p.classList.toggle('is-on', i < st.filled));
      root.classList.toggle('is-met', st.applied && st.r === 0);
      let t;
      if (st.applied && st.r === 0) t = `Sepetinde 3 AL, 2 ÖDE uygulandı: −${fmt(st.off)}.`;
      else if (st.c === 0 || st.r === 0) t = 'Üç parça seç; en düşük fiyatlı parça bizden.';
      else if (st.r === 1) t = `Sepetinde ${st.c} parça var. ${st.more} parça daha ekle.`;
      else t = `Sepetinde ${st.c} parça var. Bir parça daha ekle; en düşük fiyatlı parça bizden.`;
      if (msg.textContent !== t) msg.textContent = t;
      if (!first && key !== last) {
        if (st.applied && st.r === 0) { doby('tip'); say('Doby şapkasını kaldırdı: indirim sepette uygulandı.'); }
        else if (st.r === 2) doby('hop');
        else doby('tilt');
      }
      last = key;
    };
    const refresh = async (first) => { const c = await read(); if (c) render(stateOf(c), first); };
    refresh(true);
    const holder = document.querySelector('[data-js-cart-item-count]');
    if (holder) new MutationObserver(() => refresh(false)).observe(holder, { childList: true, characterData: true, subtree: true });

    // Doby greets once when the note is really on screen, never again on this page, and never after "Notu gizle".
    if (!off && 'IntersectionObserver' in window) {
      const io = new IntersectionObserver(([e]) => { if (e.isIntersecting) { io.disconnect(); setTimeout(() => doby('tip'), 900); } }, { threshold: .9 });
      io.observe(root);
    }
    // choosing a size: a tiny head tilt, never blocking the control (the listener is passive and does nothing but trigger the pose)
    const sizeFs = document.querySelector('[data-bv-size-fieldset]');
    if (sizeFs) sizeFs.addEventListener('change', () => doby('tilt'));
  };

  /* ---------- Kupon (ana sayfa / koleksiyon): gerçek sepetten 0/3 → 3/3; indirim yalnız cart.total_discount > 0 ise "uygulandı" ---------- */
  const initKupon = (root) => {
    if (!cfg.on) return;
    const li = [...root.querySelectorAll('.liva-kupon__yuva li')], sayi = root.querySelector('[data-liva-kupon-sayi]'), msg = root.querySelector('[data-liva-kupon-mesaj]');
    let last = null;
    const render = (st, first) => {
      li.forEach((x, i) => x.classList.toggle('is-on', i < st.filled));
      const dolu = st.c >= N && st.r === 0;
      root.classList.toggle('is-dolu', dolu && st.applied);
      sayi.textContent = (st.c >= N && st.r === 0 ? N : st.r) + ' / ' + N + (st.c > N ? ` · sepette ${st.c} parça` : '');
      let t;
      if (st.c === 0) t = 'Sepetin boş: üç parça seç, en düşük fiyatlı olan bizden.';
      else if (st.c >= N && !st.applied) t = `Sepette ${st.c} parça var ama 3 AL, 2 ÖDE şu an uygulanmıyor; sepette başka bir indirim kodu olabilir.`;
      else if (dolu) t = `Kupon dolu: sepette −${fmt(st.off)} uygulandı.`;
      else if (st.c > N) t = `Sepette −${fmt(st.off)} uygulandı. ${st.more} parça daha eklersen bir parça daha ücretsiz.`;
      else if (st.r === 1) t = 'İlk parça sepette. İki parça daha.';
      else t = 'İki parça sepette. Bir parça daha; en düşük fiyatlı olan bizden.';
      if (msg.textContent !== t) msg.textContent = t;
      const key = st.c + ':' + st.applied;
      if (!first && key !== last) document.dispatchEvent(new CustomEvent('liva:kupon', { detail: { parca: st.c, uygulandi: st.applied, indirim_kurus: st.off } }));
      if (!first && key !== last && dolu && st.applied && !reduced.matches) { root.classList.remove('is-bas'); void root.offsetWidth; root.classList.add('is-bas'); }
      last = key;
    };
    const refresh = async (first) => { const c = await read(); if (c) render(stateOf(c), first); };
    refresh(true);
    const holder = document.querySelector('[data-js-cart-item-count]');
    if (holder) new MutationObserver(() => refresh(false)).observe(holder, { childList: true, characterData: true, subtree: true });
    document.addEventListener('visibilitychange', () => { if (!document.hidden) refresh(false); });
  };

  const boot = () => {
    document.querySelectorAll('[data-liva-kupon]').forEach(initKupon);
    document.querySelectorAll('[data-bv-dnote]').forEach(initNote);
    const drawer = document.getElementById('cart-drawer');
    if (drawer) new MutationObserver(bump).observe(drawer, { childList: true, subtree: true });
    bump();
    // reveal-on-scroll for the deal section and generic .bv-rise blocks; content stays visible if observers are unavailable
    const targets = [...document.querySelectorAll('.bv-deal, .bv-rise')];
    if (!('IntersectionObserver' in window) || reduced.matches) { targets.forEach((t) => t.classList.add('is-in')); return; }
    document.documentElement.classList.add('bv-motion');
    const io = new IntersectionObserver((es) => es.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } }), { threshold: .25, rootMargin: '0px 0px -6% 0px' });
    targets.forEach((t) => io.observe(t));
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
